import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles'

import * as SiteConfig from '../../config/Config'

let ratio = SiteConfig.footerLogo.width / SiteConfig.footerLogo.height

const styles = theme => ({
  logo: {
    backgroundColor: theme.palette.background.paper,
    padding: `${SiteConfig.footerLogo.imgPadding / ratio}px ${SiteConfig.footerLogo.imgPadding}px ${SiteConfig.footerLogo.imgPadding / ratio}px ${SiteConfig.footerLogo.imgPadding}px`,
    display: "block",
    margin: "0 auto",
    marginTop: `-${SiteConfig.footerLogo.height / 2}px`,
    marginBottom: "30px",
  },
})

const FooterLogo = ({ image, altText, width, height, classes }) =>
  <img
    src={image}
    alt={altText}
    width={`${width}px`}
    height={`${height}px`}
    className={classes.logo}
  />

FooterLogo.propTypes = {
  classes: PropTypes.object.isRequired,
  image: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
};

export default withStyles(styles)(FooterLogo)


// WEBPACK FOOTER //
// ./src/components/FooterLogo/index.js